export const TILE_TYPE_CONTENT = 'content';
export const TILE_TYPE_VIDEO = 'video';
